<template>
  <teleport to="body">
    <transition name="sheet-fade">
      <div v-if="modelValue" class="fixed inset-0 bg-blue-900/40 z-50 flex justify-center items-end sm:items-center" @click.self="closeSheet">
        <transition name="sheet-slide">
          <div 
            v-if="modelValue" 
            class="bg-white rounded-t-2xl sm:rounded-xl overflow-hidden flex flex-col shadow-2xl border border-blue-100"
            :class="customClass"
            :style="{
              height: height,
              width: width,
              maxWidth: maxWidth,
              maxHeight: '90vh'
            }"
          >
            <!-- Header -->
            <div class="px-6 py-4 border-b border-blue-100 flex justify-between items-center sticky top-0 bg-gradient-to-r from-blue-900 to-blue-700 z-10">
              <!-- Drag handle for mobile -->
              <div class="absolute left-0 right-0 top-1 flex justify-center sm:hidden">
                <div class="w-12 h-1 bg-blue-200 rounded-full"></div>
              </div>
              
              <div class="flex items-center mt-2 sm:mt-0">
                <span v-if="icon" class="material-symbols-outlined text-yellow-500 mr-2">{{ icon }}</span>
                <h3 class="text-lg font-semibold text-white">{{ title }}</h3>
              </div>
              
              <button 
                @click="closeSheet" 
                class="text-blue-100 hover:text-yellow-500 focus:outline-none p-1 transition-colors"
              >
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
            
            <!-- Content -->
            <div class="flex-1 overflow-y-auto p-4 bg-blue-50">
              <slot></slot>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'AppBottomSheet',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Bottom Sheet'
    },
    icon: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '50vh'
    },
    width: {
      type: String,
      default: '100%'
    },
    maxWidth: {
      type: String,
      default: '600px'
    },
    customClass: {
      type: [String, Object, Array],
      default: ''
    }
  },
  emits: ['update:modelValue', 'close'],
  methods: {
    closeSheet() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.sheet-fade-enter-active,
.sheet-fade-leave-active {
  transition: opacity 0.3s ease;
}
.sheet-fade-enter-from,
.sheet-fade-leave-to {
  opacity: 0;
}

.sheet-slide-enter-active,
.sheet-slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
}
.sheet-slide-enter-from,
.sheet-slide-leave-to {
  transform: translateY(100%);
}
@media (min-width: 640px) {
  .sheet-slide-enter-from,
  .sheet-slide-leave-to {
    transform: translateY(20px) scale(0.98);
  }
}

.material-symbols-outlined {
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}
</style>


